import React from 'react';
import { useRouter } from 'next/router';

import { ButtonSize, ButtonType, ButtonVariant } from 'components/Button/Button';
import { Button } from 'components/Button';
import { SVG } from 'components/tokens/Icon';
import useMediaQuery from 'utils/useMediaQuery';

import styles from './FlowActions.module.scss';

interface FlowActionProps {
  actionName: string;
  actionHref?: string;
  backAction?: boolean;
  type: ButtonType;
  disabled?: boolean;
  trailingIcon?: SVG;
  previousPageUrl?: string;
}

export const FlowActions: React.FC<FlowActionProps> = ({
  actionName,
  actionHref,
  backAction,
  type,
  disabled,
  trailingIcon,
  previousPageUrl,
}) => {
  const router = useRouter();

  const PreviousPageHandler = () => {
    if (previousPageUrl) {
      router.push(previousPageUrl);
    } else {
      router.back();
    }
  };

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className={styles.wrapper}>
      {backAction && (
        <Button
          type={ButtonType.Button}
          variant={ButtonVariant.Text}
          size={isMobile ? ButtonSize.Medium : ButtonSize.Large}
          onClick={PreviousPageHandler}
          stretch={isMobile}
        >
          Tillbaka
        </Button>
      )}
      <Button
        type={type}
        variant={ButtonVariant.Primary}
        disabled={disabled}
        size={isMobile ? ButtonSize.Medium : ButtonSize.Large}
        stretch={isMobile}
        trailingIcon={!isMobile ? trailingIcon : undefined}
        href={actionHref}
      >
        {actionName}
      </Button>
    </div>
  );
};
